import { Link } from "react-router-dom";
import { useChristmasTheme } from "@/hooks/useChristmasTheme";
import { VENDEYA_LOGO_URL } from "@/components/feature/BrandLogo";

const columns = [
  {
    title: "Legal",
    links: [
      { label: "Términos de uso", path: "/legal/terms" },
      { label: "Política de privacidad", path: "/legal/privacy" },
      { label: "Política de cookies", path: "/legal/cookies" },
      { label: "Normas de la comunidad", path: "/legal/community" },
    ],
  },
];

const LIGHTS = [
  "bg-primary-500",
  "bg-secondary-500",
  "bg-accent-400",
  "bg-primary-500",
  "bg-accent-400",
  "bg-secondary-500",
];

export default function Footer() {
  const { enabled, animations } = useChristmasTheme();

  return (
    <footer className="border-t border-background-200/70 bg-background-100">
      {/* Guirnalda de luces navideñas */}
      {enabled && (
        <div
          aria-hidden="true"
          className="flex items-center justify-center gap-2.5 border-b border-background-200/70 py-3"
        >
          {LIGHTS.map((color, index) => (
            <span
              key={index}
              className={`h-2 w-2 rounded-full ${color} ${
                animations ? "xmas-twinkle" : ""
              }`}
              style={{ animationDelay: `${index * 0.25}s` }}
            ></span>
          ))}
        </div>
      )}

      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
              <span className="flex h-9 w-14 shrink-0 items-center justify-center">
                <img
                  src={VENDEYA_LOGO_URL}
                  alt="VendeYa"
                  className="h-full w-full object-contain"
                />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                Vende<span className="text-primary-500">Ya</span>
              </span>
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              El mercado de clasificados donde comprar y vender es simple, seguro y
              visualmente agradable. Publica gratis y conecta con miles de personas.
            </p>
            {enabled && (
              <p className="mt-3 max-w-xs text-sm font-medium text-secondary-700">
                🎄 VendeYa — Comparte, descubre y encuentra esta Navidad.
              </p>
            )}
            <div className="mt-6 flex items-center gap-2">
              <a
                href="#"
                aria-label="Facebook"
                className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-background-200 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-white"
              >
                <i className="ri-facebook-fill"></i>
              </a>
              <a
                href="#"
                aria-label="Instagram"
                className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-background-200 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-white"
              >
                <i className="ri-instagram-line"></i>
              </a>
              <a
                href="#"
                aria-label="X"
                className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-background-200 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-white"
              >
                <i className="ri-twitter-x-line"></i>
              </a>
              <a
                href="#"
                aria-label="YouTube"
                className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-background-200 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-white"
              >
                <i className="ri-youtube-line"></i>
              </a>
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-sm font-semibold text-foreground-950">
                {col.title}
              </h4>
              <ul className="mt-4 flex flex-col gap-3">
                {col.links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-500"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-background-200/70 pt-6 sm:flex-row">
          <p className="text-sm text-foreground-500">
            © {new Date().getFullYear()} VendeYa. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-4 text-sm text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-shield-check-line text-secondary-500"></i>
              Compra protegida
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-global-line text-secondary-500"></i>
              Español
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}